import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const DextTextInputWUT = (props)=>{
    const fieldType = FIELD_TYPES.DEXT_TEXT_INPUT;
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=dext-text-input-wut.js.map